import { globalVariable } from '../config/app'
import PaaSApi from './api/paas.api'
import TenantApi from './api/tenant.api'
import AuthApi from './api/auth.api'
import CampaignContentApi from './api/campaign_content.api'
import CampaignDataApi from './api/campaign_data.api'
import CampaignEngineApi from './api/campaign_engine.api'
import MallApi from './api/mall.api'
import MemberApi from './api/member.api'
import MessageApi from './api/message.api'
import MemberCouponApi from './api/member_coupon.api'
import BFFApi from './api/bff.api'
import AppBFFApi from './api/app_bff.api'
import LoyaltyApi from './api/loyalty.api'
import ChannelApi from './api/channel.api'
import MessageAPI from './api/messageApi'
import OrderApi from './api/order.api'
import ProductAPi from './api/product.api'
import CdpApi from './api/cdp.api'

const services = {
  paas: 'itrigger-paas',
  tenant: 'itrigger-tenant',
  auth: 'itrigger-auth',
  campaign_content: 'itrigger-campaign-content',
  campaign_data: 'itrigger-campaign-data',
  campaign_engine: 'itrigger-campaign-engine',
  mall_service: 'itrigger-mall',
  member: 'itrigger-member',
  message: 'itrigger-message',
  messageSystem: 'itrigger-message-service',
  goods: 'itrigger-sfs-product',
  order: 'itrigger-sfs-order',
  member_coupon: 'itrigger-member-coupon',
  bff: 'itrigger-bff',
  app_2e_bff: 'itrigger-app-2e-bff',
  loyalty: 'itrigger-loyalty-engine',
  channel: 'itrigger-channel-service',
  cdp: 'itrigger-analysis-service'
}

const PaaS = {
  host: globalVariable.gateway + services.paas,
  ...PaaSApi
}
const Tenant = {
  host: globalVariable.gateway + services.tenant,
  ...TenantApi
}
const AUTH = {
  host: globalVariable.gateway + services.auth,
  ...AuthApi
}
const CampaignContent = {
  host: globalVariable.gateway + services.campaign_content,
  ...CampaignContentApi
}
const CampaignData = {
  host: globalVariable.gateway + services.campaign_data,
  ...CampaignDataApi
}
const CampaignEngine = {
  host: globalVariable.gateway + services.campaign_engine,
  ...CampaignEngineApi
}
const Mall = {
  host: globalVariable.gateway + services.mall_service,
  ...MallApi
}
const Member = {
  host: globalVariable.gateway + services.member,
  ...MemberApi
}
const Message = {
  host: globalVariable.gateway + services.message,
  ...MessageApi
}
const MESSAGE = {
  host: globalVariable.gateway + services.messageSystem + '/v2/sfs/',
  ...MessageAPI
}
const PRODUCT = {
  host: globalVariable.gateway + services.goods + '/v1/sfs-product/',
  ...ProductAPi
}
const ORDER = {
  host: globalVariable.gateway + services.order + '/v1/sfs-order/',
  ...OrderApi
}
const MemberCoupon = {
  host: globalVariable.gateway + services.member_coupon,
  ...MemberCouponApi
}
const BFF = {
  host: globalVariable.gateway + services.bff,
  ...BFFApi
}
const AppBFF = {
  host: globalVariable.gateway + services.app_2e_bff,
  ...AppBFFApi
}
const Loyalty = {
  host: globalVariable.gateway + services.loyalty,
  ...LoyaltyApi
}
const Channel = {
  host: globalVariable.gateway + services.channel,
  ...ChannelApi
}
const CDP = {
  host: globalVariable.gateway + services.cdp,
  ...CdpApi
}

export default {
  globalVariable,
  PaaS,
  Tenant,
  AUTH,
  CampaignContent,
  CampaignData,
  CampaignEngine,
  Mall,
  Member,
  Message,
  MemberCoupon,
  BFF,
  AppBFF,
  Loyalty,
  Channel,
  MESSAGE,
  PRODUCT,
  ORDER,
  CDP
}
